<div class="mobile-frame">
  <div class="mobile-screen m-auto position-relative">
        <div class="mobile-screen-content w-100 h-custom overflow-x-hidden">
            <ng-container [ngTemplateOutlet]="content">
            </ng-container>
        </div>
        <!-- <div *ngIf="hoverOver" class="mobile-screen-hover d-none" (click)="hoverClick(content)">
        <p class="font-bold vpx-6 lh-lg m-auto">Click to use this template</p>
        </div> -->
   </div>
</div>